import type { IconProps } from '@magicschool/spellbook/components/Icon';
import { Icon } from '@magicschool/spellbook/components/Icon';
import { Slot } from '@magicschool/spellbook/components/Slot';
import type { SpinnerProps } from '@magicschool/spellbook/components/Spinner';
import { Spinner } from '@magicschool/spellbook/components/Spinner';
import { getControlIconSize } from '@magicschool/spellbook/lib/controls';

export const ToggleButtonLeadingIconSlot = Slot<IconProps>({
  displayName: 'ToggleButton.LeadingIcon',
  renderDefault: ({ name = 'square-dashed', size: providedSize, ...props }) => {
    const size = getControlIconSize(providedSize);
    return <Icon data-spellbook-name="toggle-button-leading-icon" name={name} size={size} {...props} />;
  },
});

export const ToggleButtonTrailingIconSlot = Slot<IconProps>({
  displayName: 'ToggleButton.TrailingIcon',
  renderDefault: ({ name = 'square-dashed', size: providedSize, ...props }) => {
    const size = getControlIconSize(providedSize);
    return <Icon data-spellbook-name="toggle-button-trailing-icon" name={name} size={size} {...props} />;
  },
});

export const ToggleButtonSpinnerSlot = Slot<SpinnerProps>({
  displayName: 'ToggleButton.Spinner',
  isRenderedByDefault: true,
  renderDefault: ({ size: providedSize, ...props }) => {
    const size = getControlIconSize(providedSize);
    return <Spinner data-spellbook-name="toggle-button-spinner" size={size} {...props} />;
  },
});
